import React from "react"
import {Box, Typography} from "@mui/material"
import {CareSpecialistEvent, ModifiedEvent} from "../types"

interface ThumbnailItemProps {
	item: ModifiedEvent
	isSelected: boolean
	onClick: (item: ModifiedEvent) => void
	thumbnailImageClass: string
}

const getThumbnailUrl = (event: ModifiedEvent): string => {
	if (event.owner === "Doc Review") return (event.docrefURL as string[])[0] ?? ""
	return (event as CareSpecialistEvent).livePreviewUrl ?? (event.docrefURL as string)
}

const ThumbnailItem: React.FC<ThumbnailItemProps> = ({
	item,
	isSelected,
	onClick,
	thumbnailImageClass,
}) => (
	<Box
		onClick={() => onClick(item)}
		sx={{
			border: isSelected ? "2px solid #1976d2" : "2px solid transparent",
			borderRadius: 1,
			cursor: "pointer",
			p: 0.5,
			"&:hover": {border: "2px solid #90caf9"},
		}}
	>
		<img src={getThumbnailUrl(item)} alt="Version thumbnail" className={thumbnailImageClass} />
		<Box sx={{mt: 0.5}}>
			<Typography variant="caption" display="block">
				Date of modification: {new Date(item.date).toLocaleDateString()}
			</Typography>
			<Typography variant="caption" display="block">
				Changed By: {item.owner}
			</Typography>
		</Box>
	</Box>
)

export default ThumbnailItem
